import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { getButton, getContent, getPercentage } from "@/src/services/litigationCase/statusBoxSteps";
import { getProductData } from "@/src/services/productService";
import { ExtraContent } from "@/src/services/litigationCase/StatusBox/ExtraContent";

export const getStatusBoxConfigEmploymentContract = (employmentContractCase: AbstractCase) => {
  const content = getContent(employmentContractCase);

  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(employmentContractCase),
    productName: getProductData(employmentContractCase.name, "label"),
    percentage: getPercentage(employmentContractCase),
    extraContent: <ExtraContent litigationCase={employmentContractCase} />,
  };
};
